import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import eventTracker from '../../../../helpers/eventTracker';
import events from '../../events';
import { Arrow, ArrowsContainer } from '../../../../styles/common-styles';

const SMDetails = ({
  spotlight_materials,
  spMaterialIndex,
  prevoiousSMHandler,
  nextSMHandler
}) => {
  const {
    mat_img,
    mat_id,
    mat_cat_header,
    mat_nm,
    mat_cat_description
  } = spotlight_materials[spMaterialIndex];

  useEffect(() => {
    eventTracker(
      events.MATERIAL_SPOTLIGHT_SCREEN_ITEM_VIEWED,
      { material_id: mat_id }
    );
  }, []);
  return (
    <>
      <DetailsImageContainer>
        <Image
          src={`https://cdn.recyclecoach.com/gallery/${mat_img}`}
          alt="blog-galery"
          height="340px"
        />
      </DetailsImageContainer>
      <ContextContainer key={spMaterialIndex}>
        <ContextCategoryHeader>
          {mat_cat_header.replace(/<[^>]+>/g, '')}
        </ContextCategoryHeader>
        <ContextTitle>
          {mat_nm}
        </ContextTitle>
        <SpMaterialDescriptionBody
          key={spMaterialIndex}
          dangerouslySetInnerHTML={{
            __html:
              mat_cat_description
          }}
        />
      </ContextContainer>

      <ArrowsContainer>
        <Arrow
          disabled={spMaterialIndex === 0}
          background="#269EE2"
          onClick={prevoiousSMHandler}
          aria-label="Previous Spotlight Material"
        >
          &#8678;
        </Arrow>
        <Arrow
          disabled={spMaterialIndex === spotlight_materials.length - 1}
          background="#269EE2"
          onClick={nextSMHandler}
          aria-label="Next Spotlight Material"
        >
          &#8680;
        </Arrow>
      </ArrowsContainer>
    </>
  );
};

export default SMDetails;

const OpacityAnimation = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const DetailsImageContainer = styled.div`
  text-align: center;
  animation: ${OpacityAnimation} 0.5s;
`;

const ContextContainer = styled.div`
  display:flex;
  flex-direction: column;
  flex: 1;
  margin-left: 20px !important;
  padding: 10px 0;
  overflow: hidden;
  animation: ${OpacityAnimation} 0.5s;
`;

const ContextCategoryHeader = styled.h2`
  margin: 0 !important;
  padding-bottom: 10px !important;
  font-size: 18px !important;
  color: #387AA8 !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: Roboto, sans-serif !important;
`;

const ContextTitle = styled.h3`
  margin: 0 !important;
  font-size: 16px !important;
  color: #404040 !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: Roboto, sans-serif !important;
`;

const SpMaterialDescriptionBody = styled.div`
  animation: ${OpacityAnimation} 0.5s;
  color: #404040 !important;

  p, li {
    color: #404040;
    font-size: 16px !important;
    font-family: Roboto, sans-serif !important;
  }

  h1, h2, h3, h4, h5, h6, b, strong{
    font-weight: bold !important;
    margin: 20px 0 15px;
  }
 
  h1 { font-size: 20px !important;   }
  h2 { font-size: 18px !important;   }
  h3 { font-size: 16px !important;   }
  h4 { font-size: 14px !important;   }
  h5 { font-size: 13px !important;   }
  h6 { font-size: 13px !important;   }
`;

const Image = styled.img`
  max-width: ${({ height }) => `${height}`};
  height: ${({ height }) => `${height}`};
  border-radius: 3px;
  object-fit: cover;
`;
